import { getIsStatusFundedOrEval } from '@/features/vest-capital/utils/status';
import { useAccountStore } from '@/store/use-account-store';
import { useMarketStore } from '@/store/use-markets-store';
import { useStore } from 'zustand';
import { getCapitalMaxLeverage } from './use-funded-account';

export default function useLeverage(symbol: string) {
  const capitalStatus = useAccountStore((state) =>
    state.getCapitalStatus(state.address),
  );

  const storeLeverage = useStore(
    useMarketStore(symbol),
    (state) => state.leverage ?? 1,
  );

  let leverage = storeLeverage;

  const capitalMaxLeverage = getCapitalMaxLeverage(symbol);

  if (leverage > capitalMaxLeverage && getIsStatusFundedOrEval(capitalStatus)) {
    leverage = capitalMaxLeverage;
  }

  return leverage;
}
